import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { getImageUrl } from '../utils/cdnUtils'
import { CUSTOMER_SLIP_CANCEL_WINDOW_MINUTES, formatCustomerSlipCancelWindowText, type LotteryRound, lotteryService } from '../services/lotteryService'
import RulesGuideModal from '../components/RulesGuideModal'

const YeekeeTermsPage: React.FC = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const [showModal, setShowModal] = useState(false)
  const [cancelWindowMinutes, setCancelWindowMinutes] = useState(CUSTOMER_SLIP_CANCEL_WINDOW_MINUTES)
  const round = (location.state as { round?: LotteryRound } | null)?.round

  useEffect(() => {
    let isMounted = true
    void lotteryService.getCustomerSlipCancelWindowMinutes().then((minutes) => {
      if (isMounted) setCancelWindowMinutes(minutes)
    })
    return () => {
      isMounted = false
    }
  }, [])
  
  return (
    <div className="content pb-3">
      <div className="container">
        <div className="row px--1">
          <div className="col-12 px-1">
            <div className="bdr-5 bx-sd mb-2">
              <div className="row mx--1">
                <div className="col-12 px-1">
                  <div className="w-100 p-2 bgc-4 wrap justify-content-between">
                    <a 
                      href="#"
                      className="txt-link-d"
                      onClick={() => navigate('/yeekee')}
                    >
                      <i className="fas fa-chevron-left me-1"></i>
                      หน้าแทงหวย
                    </a>

                    <a
                      href="#"
                      className="bdr-5 c-white bgg-4 txt-link px-2"
                      onClick={(e) => {
                        e.preventDefault()
                        setShowModal(true)
                      }}
                    >
                      กติกา & วิธีเล่น
                    </a>
                  </div>
                </div>

                <div className="col-12 px-1">
                  <div className="w-100 p-2 bgc-7">
                    <div className="bdr-5 bgc-4 c-red px-2 py-1 wrap justify-content-between">
                      <div className="wrap">
                        <div className="icon-f">
                          <img src={getImageUrl('flag/us.png')} alt="" />
                        </div>
                        <p className="mx-2 fs-18 t-medium">หุ้นดาวน์โจนส์</p>
                      </div>
                      <div className="bgc-9 bdr-5 py-1 px-2 c-white wrap justify-content-center">
                        <small>22-Aug-2024 02:00</small>
                      </div>
                    </div>

                    <div className="row mx--1">
                      <div className="col-12 col-md-4 px-1 mt-2">
                        <a
                          href="#"
                          className="bgg-1 p-1 bdr-5 text-center box-hover"
                          onClick={(e) => {
                            e.preventDefault()
                            navigate('/lottery-bet')
                          }}
                        >
                          <div className="bgc-4 bdr-5 p-1 t-regular c-red">
                            <h5>PACK-A</h5>
                          </div>
                          <div className="px-1 py-2 c-white">
                            <h5>2 ตัวล่าง</h5>
                            <h6 className="c-main wrap align-items-start justify-content-center">
                              จ่าย
                              <span className="txt-st t-medium px-2">100</span>
                              บาท
                            </h6>
                            <h5>ลด 0%</h5>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <RulesGuideModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        scope={round ? {
          huayId: round.huayId,
          huayName: round.huayName,
          huayTypeId: round.huayTypeId,
          huayTypeName: round.huayTypeName,
        } : undefined}
        closeButtonLabel="ยอมรับและตกลง"
        fallbackRules={(
          <div className="text-center">
            <p>- ระบบเปิด-ปิดแทงตามเวลาที่ได้แจ้งไว้ และบริษัทสามารถพิจารณาปิดแทงก่อนกำหนดได้</p>
            <p>- ทางบริษัทสามารถคืนเลขได้ทุกกรณี แต่จะคืนก่อนที่จะออกผลรางวัล</p>
            <p>- การคืนเลขหรือคืนโพยของสมาชิก ต้องเป็นไปเงื่อนไขและเวลาที่ทางเว็บกำหนดเท่านั้น (<span style={{ color: '#ff0000' }}><strong>คืนโพยได้ภายใน {formatCustomerSlipCancelWindowText(cancelWindowMinutes)}หลังจากที่แทง</strong></span>)</p>
            <p>- หากหวยนั้นๆ มีการออกผลรางวัลก่อนที่จะปิดแทง บริษัทจะทำการยกเลิกรายการที่แทงเฉพาะบางเลขที่ได้ทำการแทงหลังจากหวยนั้นๆ ออกผล</p>
            <p>- ราคาจ่ายและส่วนลดจะลดลงตามเลขดังหรือเลขอั้น ให้สมาชิกตรวจสอบโพยและราคาจ่าย/ส่วนลดหลังการแทงทุกครั้ง</p>
            <p>- การสมัครสมาชิกหรือแนะนำชื่อตัวเองเพื่อปั่นค่าคอมมิชชั้น จะถูกพิจารณาปิดบัญชีและยึดเครดิตของบัญชีที่เกี่ยข้องทั้งหมด</p>
            <p>- สมาชิกที่จงใจเจตนาทุจริตในการเล่น จะถูกปิดบัญชีและไม่คืนเครดิตให้ทุกกรณี</p>
            <p>- กรณีที่เซฟเวอร์หรืออินเตอร์เน็ตล่มในช่วงการเปิดรับแทง และเกิดข้อโต้แย้งเกี่ยวกับการออกผลรางวัล ทางบริษัทมีสิทธิ์จะพิจารณายกเลิกรายการงวดและคืนเครดิตให้ลูกค้า</p>
            <p>- ผลรางวัลคลุมเครือหรือมีแนวโน้มที่ไม่โปร่งใส ทางบริษัทจะพิจารณายกเลิกรายการงวดและคืนเครดิตให้ลูกค้า</p>
            <p>- ในกรณีเกิดข้อพิพาทและโต้แย้งในการออกผลรางวัล การตัดสินของบริษัทถือเป็นข้อยุติและสิ้นสุด</p>
            <p>- <span style={{ color: '#ff0000' }}>สมาชิกที่สมัครมากกว่า 1 ยูสเซอร์ โดยใช้ชื่อเดียวกัน เพื่อผลประโยชน์ในการแทงได้มากกว่าหรือปั่นค่าแนะนำ จะถูกระงับและไม่คืนเครดิตให้ทุกรณี</span></p>
          </div>
        )}
        fallbackGuides={(
          <div className="mt-5">
            <p className="text-center"><strong><u>วิธีการดูผลรางวัล "หุ้นดาวน์โจนส์"</u></strong></p>
            <p className="text-center">สามตัวบน (172) สองตัวล่าง (27)</p>
            <p className="mb-4"><strong><u>การตรวจผลรางวัล</u></strong></p>
            <div className="table-responsive">
              <table className="table table-hover mb-0">
                <tbody>
                  <tr><td style={{ width: '100px' }}>3 ตัวบน</td><td>172</td></tr>
                  <tr><td>2 ตัวบน</td><td>27</td></tr>
                  <tr><td>2 ตัวโต๊ด</td><td>17 12 71 72 21 27</td></tr>
                  <tr><td>3 ตัวโต๊ด</td><td>127 127 712 721 217 271</td></tr>
                  <tr><td>วิ่งบน</td><td>1 - 7 - 2</td></tr>
                  <tr><td>ปักหลักร้อย</td><td>1</td></tr>
                  <tr><td>ปักหลักสิบ</td><td>7</td></tr>
                  <tr><td>ปักหลักหน่วย</td><td>2</td></tr>
                  <tr><td>2 ตัวล่าง</td><td>27</td></tr>
                  <tr><td>วิ่งล่าง</td><td>2 - 7</td></tr>
                </tbody>
              </table>
            </div>
          </div>
        )}
      />
    </div>
  )
}

export default YeekeeTermsPage
